// 22.01.19 - These are all convenience functions definitions used by the Sagas and reducers etc.
import { ActionTypes } from "../constants/actions";
import { IUserDetail } from "src/constants/api";

/* This getCasedataAction
    - Handled in saga/home.tsx: Fetches all the cases from the server.
*/
export const getCaseData = () => ({
  type: ActionTypes.HOME.GET_ALL_CASES,
});

/* This getCasedataByUserAction
    - Handled in saga/home.tsx: Fetches all the cases from the server.
*/
export const getCaseDataByUser = (UserRoleId: string, UserName: string) => ({
  type: ActionTypes.HOME.GET_ALL_CASES_BY_USER,
  payload: [UserRoleId, UserName],
});

/* The `fetchUserData` action
   - Handled in saga/home.tsx: Fetches the user's information from the server. 
   - Note: Upon success, the data is sent to reducers via `userDataReceived`
*/
export const fetchUserData = (email: string) => ({
  type: ActionTypes.HOME.FETCH_USER_DATA,
  payload: email,
});

export const fetchLoggedUserData = () => ({
  type: ActionTypes.HOME.FETCH_LOGGED_USER_DATA,  
});

/* This userDataReceived action.
   - Handledd in reducers/home.tsx: Stores the user data payload as the current user.
   - Note: the payload can be `undefined` for testing purposes, so that we can "log out". 
*/
export const userDataReceived = (user: IUserDetail | undefined) => ({
  type: ActionTypes.HOME.USER_DATA_RECEIVED,
  payload: user,
});

/* The `fetchInitialData` action
   - Handled in saga/home.tsx: Initiates the initial data fetch.
*/
export const fetchInitialData = () => ({
  type: ActionTypes.HOME.FETCH_INITIAL_DATA,
});

export const actionGetGridData = (UserRoleId: string, UserName: string) => ({
  type: ActionTypes.HOME.GET_GRID_DATA,
  payload: [UserRoleId, UserName],
});

export const actionSuccessGetGridData = (gridData: any) => ({
  type: ActionTypes.HOME.SUCCESS_GET_GRID_DATA,
  payload: gridData,
});

export const actionShowNoDataMessage = (showMessage: boolean) => ({
  type: ActionTypes.HOME.SHOW_NO_DATA_MESSAGE,
  payload: showMessage,
});

export const actionExportComplaintData = () => ({
  type: ActionTypes.HOME.EXPORT_COMPLAINT,
});

export const actionExportClaimData = () => ({
  type: ActionTypes.HOME.EXPORT_CLAIM,
});

export const actionExportIncidentReportData = () => ({
  type: ActionTypes.HOME.EXPORT_INCIDENT_REPORT,
});
